import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LogService } from 'src/app/core/services/ticket/log.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { WindowRef } from '@sb-tools/typescript/services/window-ref.service';
import { OrderBy } from '@sb-tools/typescript/enums/order-by.enum';
import { TicketActionViewModel } from '../../../core/models/ticket-action-view-model.model';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { DatePipe, NgClass } from '@angular/common';
import { HighlightEntityComponent } from '../../../shared/components/highlight-entity/highlight-entity.component';
import { LoaderComponent } from '../../../../sb-tools/typescript/components/loader/loader.component';
import { TranslateModule } from '@ngx-translate/core';
import { TicketTimePipe } from '../../../../sb-tools/typescript/pipes/ticket/ticket-time.pipe';

const ACTION_LOG_SORTING_TYPE_KEY = 'actionLogSortingTypeKey';

@Component({
    selector: 'app-ticket-log',
    templateUrl: './ticket-log.component.html',
    styleUrls: ['./ticket-log.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TooltipModule,
        NgClass,
        HighlightEntityComponent,
        LoaderComponent,
        TranslateModule,
        DatePipe,
        TicketTimePipe,
    ],
})
export class TicketLogComponent implements OnInit, OnDestroy {
    @Input() ticketId: number;

    isAscSort: boolean;
    isLogLoading;
    isWholeLogLoaded;
    ticketLog = [];

    private count = 100;
    private unsubscriber = new Subject<void>();

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private logService: LogService,
        private windowRef: WindowRef,
    ) {}

    ngOnInit(): void {
        this.isAscSort = this.windowRef.nativeWindow.localStorage.getItem(ACTION_LOG_SORTING_TYPE_KEY) === 'true';
        this.loadLog();
    }

    loadLog(isGetFirst = false): void {
        this.isLogLoading = true;

        this.logService
            .getAll(this.ticketId, {
                skip: isGetFirst ? 0 : this.ticketLog.length,
                take: this.count,
                orderBy: this.isAscSort ? OrderBy.creationTimeAsc : OrderBy.creationTimeDesc,
            })
            .pipe(
                finalize(() => {
                    this.isLogLoading = false;
                    this.changeDetectorRef.detectChanges();
                }),
                takeUntil(this.unsubscriber),
            )
            .subscribe((data: TicketActionViewModel[]) => {
                this.isWholeLogLoaded = data.length + 1 <= this.count;
                data.length = data.length > this.count ? this.count : data.length;
                if (isGetFirst) {
                    this.ticketLog = data;
                } else {
                    Array.prototype.push.apply(this.ticketLog, data);
                }
                this.changeDetectorRef.detectChanges();
            });
    }

    sortLogs(): void {
        this.isAscSort = !this.isAscSort;
        this.windowRef.nativeWindow.localStorage.setItem(ACTION_LOG_SORTING_TYPE_KEY, `${this.isAscSort}`);

        this.loadLog(true);
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
